var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex flex-wrap" }, [
    _c(
      "div",
      {
        staticClass:
          "w-full bg-gray-bg z-50 sticky pin-t md:relative md:w-1/4 pt-2 pb-5",
      },
      [
        _c("input", { attrs: { id: "dropdown", type: "checkbox" } }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass:
              "mobile__dropdown md:hidden block bg-black text-white uppercase text-lg px-3 py-3",
            attrs: { for: "dropdown" },
          },
          [
            _vm._v("\n      Step: " + _vm._s(_vm.pageTitle) + "\n      "),
            _c("span", { staticClass: "float-right" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "20",
                    height: "17",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M10 16.667L0 0h20z",
                      fill: "#FFF",
                      "fill-rule": "evenodd",
                    },
                  }),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass:
              "list-reset nav__sidebar border-b-8 md:border-b-0 md:border-t-8 border-black overflow-hidden md:overflow-visible md:h-auto md:opacity-100",
          },
          [
            _vm.user.isAdmin
              ? _c(
                  "li",
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "font-sans-bold text-red",
                        attrs: { to: `/events/${_vm.eventId}/admin` },
                      },
                      [_vm._v("\n          Admin Settings\n        ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.eventRoutes, function (eventRoute) {
              return _c(
                "li",
                { key: eventRoute.to },
                [
                  _c(
                    "router-link",
                    {
                      class: {
                        errors: !eventRoute.status && _vm.eventHasErrors,
                      },
                      attrs: { to: eventRoute.to },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(eventRoute.text) +
                          "\n          "
                      ),
                      eventRoute.status
                        ? _c(
                            "span",
                            { staticClass: "flex flex-1 justify-end" },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "active-white",
                                  attrs: {
                                    width: "28",
                                    height: "29",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                  },
                                },
                                [
                                  _c("defs", [
                                    _c("path", {
                                      attrs: {
                                        id: "a",
                                        d: "M0 .557h27.444V28H0z",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        fill: "none",
                                        "fill-rule": "evenodd",
                                      },
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            transform: "translate(0 .318)",
                                          },
                                        },
                                        [
                                          _c(
                                            "mask",
                                            {
                                              attrs: { id: "b", fill: "#fff" },
                                            },
                                            [
                                              _c("use", {
                                                attrs: { "xlink:href": "#a" },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d: "M21.483 22.041c-4.286 4.286-11.237 4.286-15.523 0-4.288-4.287-4.288-11.238 0-15.524 4.286-4.288 11.237-4.288 15.524-.001 4.286 4.287 4.286 11.238 0 15.525M4.018 4.576c-5.358 5.358-5.358 14.046 0 19.405 5.359 5.36 14.046 5.36 19.406 0 5.358-5.359 5.358-14.047 0-19.405-5.36-5.359-14.047-5.359-19.406 0",
                                              fill: "#000",
                                              mask: "url(#b)",
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d: "M12.35 21.458c-.327 0-.644-.117-.895-.332l-4.803-4.127a1.372 1.372 0 0 1 1.789-2.082l3.627 3.117 6-9.001a1.372 1.372 0 1 1 2.284 1.522l-6.861 10.29a1.366 1.366 0 0 1-1.141.613",
                                          fill: "#000",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _c(
                            "span",
                            { staticClass: "flex flex-1 justify-end" },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "tab-status-incomplete",
                                  attrs: {
                                    width: "28",
                                    height: "29",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    "xmlns:xlink":
                                      "http://www.w3.org/1999/xlink",
                                  },
                                },
                                [
                                  _c("defs", [
                                    _c("path", {
                                      attrs: {
                                        id: "a",
                                        d: "M0 .557h27.444V28H0z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        transform: "translate(0 .318)",
                                        fill: "none",
                                        "fill-rule": "evenodd",
                                      },
                                    },
                                    [
                                      _c(
                                        "mask",
                                        { attrs: { id: "b", fill: "#fff" } },
                                        [
                                          _c("use", {
                                            attrs: { "xlink:href": "#a" },
                                          }),
                                        ]
                                      ),
                                      _c("path", {
                                        attrs: {
                                          d: "M21.483 22.041c-4.286 4.286-11.237 4.286-15.523 0-4.288-4.287-4.288-11.238 0-15.524 4.286-4.288 11.237-4.288 15.524-.001 4.286 4.287 4.286 11.238 0 15.525M4.018 4.576c-5.358 5.358-5.358 14.046 0 19.405 5.359 5.36 14.046 5.36 19.406 0 5.358-5.359 5.358-14.047 0-19.405-5.36-5.359-14.047-5.359-19.406 0",
                                          fill: "#9B9B9B",
                                          mask: "url(#b)",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                    ]
                  ),
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "text-grey-darkest",
                    attrs: { to: `/events/${_vm.eventId}/submit` },
                  },
                  [
                    _vm.event.status === "new"
                      ? [
                          _vm._v("Submit for Review "),
                          _c(
                            "span",
                            { staticClass: "flex flex-1 justify-end" },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "right active-white",
                                  attrs: {
                                    width: "17",
                                    height: "16",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M13.16 6.99L7.578 1.412 8.99 0 17 8l-8.01 8-1.413-1.412 5.608-5.601H0V6.99z",
                                      fill: "#010B19",
                                      "fill-rule": "evenodd",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : [
                          _vm._v("Event Status "),
                          _c(
                            "span",
                            { staticClass: "flex flex-1 justify-end pr-1" },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "float-right mt-1 active-white",
                                  attrs: {
                                    width: "17",
                                    height: "16",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M13.16 6.99L7.578 1.412 8.99 0 17 8l-8.01 8-1.413-1.412 5.608-5.601H0V6.99z",
                                      fill: "#010B19",
                                      "fill-rule": "evenodd",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ],
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "router-link",
                  {
                    staticClass: "text-grey-darkest",
                    attrs: { to: `/events/${_vm.eventId}/duplicate` },
                  },
                  [
                    [
                      _vm._v("\n            Duplicate Event\n            "),
                      _c(
                        "span",
                        { staticClass: "flex flex-1 justify-end pr-1" },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                height: "24px",
                                width: "24px",
                                fill: "#000000",
                                xmlns: "http://www.w3.org/2000/svg",
                                x: "0px",
                                y: "0px",
                                viewBox: "0 0 100 100",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    transform: "translate(0,-952.36218)",
                                  },
                                },
                                [
                                  _c("path", {
                                    staticStyle: {
                                      "font-size": "medium",
                                      "font-style": "normal",
                                      "font-variant": "normal",
                                      "font-weight": "normal",
                                      "font-stretch": "normal",
                                      "text-indent": "0",
                                      "text-align": "start",
                                      "text-decoration": "none",
                                      "line-height": "normal",
                                      "letter-spacing": "normal",
                                      "word-spacing": "normal",
                                      "text-transform": "none",
                                      direction: "ltr",
                                      "block-progression": "tb",
                                      "writing-mode": "lr-tb",
                                      "text-anchor": "start",
                                      "baseline-shift": "baseline",
                                      opacity: "1",
                                      color: "#000000",
                                      fill: "#000000",
                                      "fill-opacity": "1",
                                      stroke: "none",
                                      "stroke-width": "6",
                                      marker: "none",
                                      visibility: "visible",
                                      display: "inline",
                                      overflow: "visible",
                                      "enable-background": "accumulate",
                                      "font-family": "Sans,serif",
                                      "-inkscape-font-specification": "Sans",
                                    },
                                    attrs: {
                                      d: "M 27.6875 5 A 3.0003 3.0003 0 0 0 25 8 L 25 25 L 8 25 A 3.0003 3.0003 0 0 0 5 28 L 5 92 A 3.0003 3.0003 0 0 0 8 95 L 72 95 A 3.0003 3.0003 0 0 0 75 92 L 75 75 L 92 75 A 3.0003 3.0003 0 0 0 95 72 L 95 8 A 3.0003 3.0003 0 0 0 92.3125 5 A 3.0003 3.0003 0 0 0 92 5 L 28 5 A 3.0003 3.0003 0 0 0 27.6875 5 z M 31 11 L 89 11 L 89 69 L 75 69 L 75 28 A 3.0003 3.0003 0 0 0 72.3125 25 A 3.0003 3.0003 0 0 0 72 25 L 31 25 L 31 11 z M 11 31 L 69 31 L 69 89 L 11 89 L 11 31 z ",
                                      transform: "translate(0,952.36218)",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.event.published
              ? _c("li", [
                  _c(
                    "a",
                    {
                      staticClass: "text-grey-darkest",
                      attrs: { href: _vm.event.public_url, target: "_blank" },
                    },
                    [
                      _c("span", [_vm._v("View Published Page")]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "flex flex-1 justify-end pr-1" },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "26",
                                height: "26",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    fill: "none",
                                    "fill-rule": "evenodd",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M13.031 9.525a.633.633 0 00-.81.343.633.633 0 00.343.81c.592.25 1.122.592 1.558 1.029a4.722 4.722 0 010 6.67l-3.771 3.771a4.616 4.616 0 01-3.335 1.372c-1.278 0-2.432-.5-3.336-1.372a4.722 4.722 0 010-6.67l3.772-3.771a.603.603 0 000-.873.603.603 0 00-.873 0l-3.771 3.771c-2.307 2.307-2.307 6.11 0 8.416a5.919 5.919 0 004.208 1.745c1.59 0 3.085-.623 4.207-1.745l3.772-3.772c2.306-2.306 2.306-6.109 0-8.415a6.024 6.024 0 00-1.964-1.31",
                                      fill: "#000",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M13.031 9.525a.633.633 0 00-.81.343.633.633 0 00.343.81c.592.25 1.122.592 1.558 1.029a4.722 4.722 0 010 6.67l-3.771 3.771a4.616 4.616 0 01-3.335 1.372c-1.278 0-2.432-.5-3.336-1.372a4.722 4.722 0 010-6.67l3.772-3.771a.603.603 0 000-.873.603.603 0 00-.873 0l-3.771 3.771c-2.307 2.307-2.307 6.11 0 8.416a5.919 5.919 0 004.208 1.745c1.59 0 3.085-.623 4.207-1.745l3.772-3.772c2.306-2.306 2.306-6.109 0-8.415a6.024 6.024 0 00-1.964-1.31z",
                                      stroke: "#000",
                                      "stroke-width": ".5",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M23.005 2.823a5.918 5.918 0 00-4.208-1.745c-1.59 0-3.085.623-4.239 1.745l-3.771 3.772c-2.307 2.306-2.307 6.109 0 8.415a6.024 6.024 0 001.964 1.31c.093.03.155.03.249.03.25 0 .499-.124.592-.373a.633.633 0 00-.343-.81c-.592-.219-1.122-.593-1.558-1.03a4.722 4.722 0 010-6.67l3.771-3.77c.904-.874 2.057-1.372 3.335-1.372 1.279 0 2.432.467 3.335 1.371a4.721 4.721 0 010 6.67l-3.771 3.772a.603.603 0 000 .872c.25.25.623.25.873 0l3.771-3.771c2.338-2.306 2.338-6.11 0-8.416",
                                      fill: "#000",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M23.005 2.823a5.918 5.918 0 00-4.208-1.745c-1.59 0-3.085.623-4.239 1.745l-3.771 3.772c-2.307 2.306-2.307 6.109 0 8.415a6.024 6.024 0 001.964 1.31c.093.03.155.03.249.03.25 0 .499-.124.592-.373a.633.633 0 00-.343-.81c-.592-.219-1.122-.593-1.558-1.03a4.722 4.722 0 010-6.67l3.771-3.77c.904-.874 2.057-1.372 3.335-1.372 1.279 0 2.432.467 3.335 1.371a4.721 4.721 0 010 6.67l-3.771 3.772a.603.603 0 000 .872c.25.25.623.25.873 0l3.771-3.771c2.338-2.306 2.338-6.11 0-8.416z",
                                      stroke: "#000",
                                      "stroke-width": ".5",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.user.isAdmin && _vm.event.id
              ? _c(
                  "li",
                  [
                    _c("AdminQueuetonStatus", {
                      attrs: { resource: "event", "resource-id": _vm.event.id },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-full md:w-3/4 md:pl-6" },
      [_c("router-view")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }